import React from 'react';
import { Box, Skeleton, Grid, useTheme } from '@mui/material';
import FormSection from '../forms/FormSection';
import FormColumn from '../forms/FormColumn';
import FormRow from '../forms/FormRow';

function FormSkeleton({ 
    title = "",
    rows = 3, 
    fieldsPerRow = 3 
}) {
    const theme = useTheme();
    
    const renderSkeletonField = (key) => (
        <Grid item xs={12} sm={6} md={4} key={key} sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            width: '100%',
            gap: theme.spacing(1),
        }}>
            <Skeleton
                variant="rectangular" 
                width="30%" 
                height={24}
                sx={{ 
                    borderRadius: '0.5rem',
                    backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }} 
            />
            <Skeleton
                variant="rectangular" 
                width="100%" 
                height={56} 
                sx={{ 
                    borderRadius: '0.5rem',
                    backgroundColor: 'rgba(0, 0, 0, 0.06)'
                }} 
            />
        </Grid>
    );

    const renderSkeletonRow = (rowIndex) => (
        <FormRow key={rowIndex}>
            {Array.from({ length: fieldsPerRow }, (_, fieldIndex) => 
                renderSkeletonField(`row-${rowIndex}-field-${fieldIndex}`)
            )}
        </FormRow>
    );

    return (
        <Box p={3}>
            <FormSection title={title}>
                <FormColumn>
                    {Array.from({ length: rows }, (_, rowIndex) => 
                        renderSkeletonRow(rowIndex)
                    )}
                </FormColumn>
            </FormSection>
        </Box>
    );
}

export default FormSkeleton;
